import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';

export const initialLoadSplitIssueModalExperience = new UFOExperience('split-issue-modal-load', {
	type: ExperienceTypes.Operation,
	performanceType: ExperiencePerformanceTypes.PageLoad,
});

export const saveSplitIssuesExperience = new UFOExperience('split-issue-save', {
	type: ExperienceTypes.Operation,
	performanceType: ExperiencePerformanceTypes.InlineResult,
});
